<template>
  <div class="teacher_detail">
    <div class="teacher_head">
      <div class="img">
        <img :src="params.designer.headPath" alt />
      </div>
      <h3>{{params.name}}</h3>
      <h4>{{params.school_name}} | {{params.faculty}}</h4>
      <!-- 关注设计师按钮 -->
      <createFollow
        v-if="!attention.attention_flag"
        :designer_obj="params.designer"
        :attention="attention"
      ></createFollow>
      <!-- 取消关注设计师按钮 -->
      <cancelFollow v-else :designer_obj="params.designer" :attention="attention"></cancelFollow>
      <div class="filtrate">
        <div class="filtrate_box m">
          <ul class="filtrate_box_l">
            <li :class="{active:$route.path === '/designer/teacher_opus'}">
              <router-link :to="'/designer/teacher_opus?id='+params.id+'&user='+params.user">作品</router-link>
            </li>
            <li :class="{active:$route.path === '/designer/teacher_mien'}">
              <router-link :to="'/designer/teacher_mien?id='+params.id+'&user='+params.user">个人风采</router-link>
            </li>
            <li :class="{active:$route.path === '/designer/teacher_praise'}">
              <router-link :to="'/designer/teacher_praise?id='+params.id+'&user='+params.user">赞过</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="teacher_box m">
      <router-view />
    </div>
  </div>
</template>

<script>
import createFollow from "@/components/followDesigner/createFollow.vue";
import cancelFollow from "@/components/followDesigner/cancelFollow.vue";
export default {
  components: {
    createFollow,
    cancelFollow
  },
  data() {
    return {
      params: {
        designer: {}
      },
      attention: {
        attention_flag: false
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    //查询教师
    getData() {
      let params = {
        user: this.$route.query.user
      };
      this.api.getFrontTeachers(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.params = res.obj.list[0] || {};
        this.attention.attention_flag = this.params.designer.isFollow;
      });
    }
  }
};
</script>

<style lang="scss">
.teacher_detail {
  .teacher_head {
    height: 326px;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url("~@/assets/img/designer/teacher_bg.png");
    box-sizing: border-box;
    .img {
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    h3 {
      font-size: 16px;
      color: #fff;
      margin-top: 20px;
    }
    h4 {
      font-size: 13px;
      color: #fff;
      margin-top: 10px;
    }
  }
   .filtrate {
    height: 80px;
    .filtrate_box {
      display: flex;
      justify-content: center;
      ul {
        display: flex;
      }
      ul li {
        line-height: 55px;
        position: relative;
        margin-right: 60px;
        cursor: pointer;
        a {
          display: block;
          width: 100%;
          height: 100%;
          color: #fff;
          font-size: 16px;
        }
        span {
          color: #ff733c;
        }
      }
      ul li.active a {
        color: $color-default;
      }
      ul li.active {
        &:before {
          position: absolute;
          content: "";
          width: 29px;
          height: 3px;
          background-color: $color-default;
          bottom: 7px;
          right: 0;
          left: 0;
          margin: 0 auto;
        }
      }
      .filtrate_box_r {
        display: flex;
        align-items: center;
      }
    }
  }
  .teacher_box {
  }
}
</style>
